export default __webpack_public_path__ + "static/media/Calculate.29d2186e.png";